import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import { AssetFinanceUrl } from "../../../../config";
import Form from "./form";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
import Joyride from "react-joyride";
import { executeAnyMutation } from "../../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const base_url = AssetFinanceUrl.uri;

const tourSteps = [
  {
    target: ".dynamic-table-header",
    content: "Manage the approved valuer firms for collateral asset valuations.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find valuer firms by name or registration number.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new Valuer Firm.",
    placement: "right",
  },
];

const ValuerFirmTable = () => {
  const [runTour, setRunTour] = useState(false);

  const handleToggleApproval = async (row, refetch) => {
    const isCurrentlyApproved = !!row?.IsApproved;
    const action = isCurrentlyApproved ? "Revoke Approval" : "Approve";
    const confirm = await Swal.fire({
      title: `${action} Valuer Firm?`,
      text: `Are you sure you want to ${action.toLowerCase()} "${row.Name}"?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
    });
    if (!confirm.isConfirmed) return;

    const response = await executeAnyMutation(
      "updateValuerFirm",
      {
        id: row.Id,
        name: row.Name,
        companyId: row.CompanyId,
        isApproved: !isCurrentlyApproved,
        approvedAt: !isCurrentlyApproved ? new Date().toISOString() : null,
        approvedBy: !isCurrentlyApproved
          ? parseInt(JSON.parse(localStorage.getItem("decodedToken"))?.UserId || 0)
          : null,
      },
      "valuerFirm",
      false,
      base_url
    );

    if (response?.results) {
      await Swal.fire("Done!", `Valuer Firm has been ${!isCurrentlyApproved ? "approved" : "revoked"}.`, "success");
      if (refetch) refetch();
    } else {
      await Swal.fire("Error!", "Could not update the Valuer Firm. Please try again.", "error");
    }
  };

  const actions = {
    entity: localStorage.getItem("SelectedTabLabel") || "Valuer Firm",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    toggleApproval: {
      key: "TOGGLE_APPROVAL",
      button_name: (row) => (row?.IsApproved ? "Revoke Approval" : "Approve"),
      Show_Button: true,
      permission: "EditPermission",
      onClick: (row, refetch) => handleToggleApproval(row, refetch),
    },
    dataObject: {
      ignoreFields: ["CreatedAt", "CreatedBy", "UpdatedAt", "UpdatedBy", "CompanyId", "ApprovedAt", "ApprovedBy"],
      objectName: "allValuerFirms",
      parameters: "",
    },
    isSubRight: true,
    showStatus: true,
    showMore: {
      search: false,
      min: 0,
      max: 0
    }
  };

  return (
    <Box m="20px">
      <Joyride
        steps={tourSteps}
        run={runTour}
        continuous
        showSkipButton
        showProgress
        styles={{
          options: {
            primaryColor: "#1976d2",
            zIndex: 10000,
          },
        }}
      />
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
          Start Page Tour
        </Button>
      </Box>
      <DynamicTableForJson
        title="Valuer Firm Management"
        subtitle="Manage Valuer Firms for Collateral Valuations"
        FormComponent={Form}
        actions={actions}
        base_url={base_url}
        tourSteps={tourSteps}
      />
    </Box>
  );
};

export default ValuerFirmTable;
